import React from "react";
import imgLogo from "../../assets/images/logo.png"
import moment from "moment/moment";

function PrintHeader(props) {
    return (
        <>
            <div className="report-header">
                <table style={{ width: "100%" }}>
                    <tr>
                        <td style={{ width: "50%" }}>
                            <div className="logo">
                                <img src={imgLogo} alt="logo" />
                            </div>
                        </td>
                        <td style={{ textAlign: "right", fontSize: "10pt", verticalAlign: "top" }}>
                            <div><b>Printed on:</b></div>
                            <div>{moment().format("MMMM Do YYYY, h:mm:ss a")}</div>
                        </td>
                    </tr>
                </table>
            </div>
            {props.title ? (
                <h3 style={{ fontSize: "13pt", marginTop: 0, marginBottom: "12px" }}>{props.title}</h3>
            ) : null}
        </>
    );
}

export default PrintHeader;